// startup
// Load entry module and return exports
__webpack_require__(887448);
// This entry module used 'module' so it can't be inlined
var __webpack_exports__ = __webpack_require__(682980);
